import {
  createStandaloneToast,
  useToast,
  theme,
} from '@frontend/legacy-components';

const { toast } = createStandaloneToast({ theme });

export const notifySuccess = (title, description) =>
  toast({ status: 'success', title, description });

export const notifyError = (title, description) =>
  toast({ status: 'error', title, description });

export const notifyWarning = (title, description) =>
  toast({ status: 'warning', title, description });

export const useNotify = (options) => {
  const toast = useToast(options);

  const buildNotify = (status) => (title, description) =>
    toast({ status, title, description });

  return {
    success: buildNotify('success'),
    error: buildNotify('error'),
    warning: buildNotify('warning'),
    info: buildNotify('info'),
  };
};
